import { render, staticRenderFns } from "./goods-code-label.vue?vue&type=template&id=74d3af0f&scoped=true"
import script from "./goods-code-label.vue?vue&type=script&lang=js"
export * from "./goods-code-label.vue?vue&type=script&lang=js"
import style0 from "./goods-code-label.vue?vue&type=style&index=0&id=74d3af0f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d3af0f",
  null
  
)

export default component.exports